export const sendFeedbackFormApi = (backEndUrl: string, courseGuid: string, payload: FormData): Promise<Response> => {
  return fetch(`${backEndUrl}/api/v1/feedback-form/submit-feedback/${courseGuid}`, {
    method: 'POST',
    body: payload,
  });
};
